import { ILogger } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { ILocalEditEvents, LocalEditEvents } from '../core/interfaces/local-edit-events.interface';
import { LocalEditServices } from '../core/local-edit-services.core';
import { ConvertStage } from '../core/interfaces/convert-error-modal.interface';
import { SaveType } from '@tencent/mega-sdk-protocols';

const MODULE = '[LocalEditNoticeManager]';

export class LocalEditNoticeManager {
    public constructor(private logger: ILogger, private emitter: ILocalEditEvents) {
        this.emitter.on(LocalEditEvents.LoadDocumentAllChunksSuccess, () => {
            this.logger.info(MODULE, 'PasswordModal', 'close()');
        });

        this.emitter.on(LocalEditEvents.LoadDocumentError, (error) => {
            LocalEditServices.UI.ConvertErrorModal.promise().then((modal) => {
                modal.show({
                    error,
                    stage: ConvertStage.Load,
                });
            });
        });

        this.emitter.on(LocalEditEvents.SlideAppDataError, (error) => {
            this.logger.info(MODULE, 'SlideAppDataError', 'error.stack', error?.stack);
            LocalEditServices.UI.ConvertErrorModal.promise().then((modal) => {
                modal.show({
                    error,
                    stage: ConvertStage.Load,
                });
            });
        });

        this.emitter.on(LocalEditEvents.SaveDocumentError, (error, lastSaveType) => {
            LocalEditServices.UI.ConvertErrorModal.promise().then((modal) => {
                modal.show({
                    error,
                    stage: ConvertStage.Save,
                    retry: async (forceSaveType?: SaveType) => {
                        const localEditManager = await LocalEditServices.LocalEditManager.promise();
                        await localEditManager.save(forceSaveType ?? lastSaveType);
                    },
                });
            });
        });
    }
}
